import { useEffect, useState } from 'react';
import { useImageFallback } from '@voll-intelligence/ui-kit/hooks/use-image-fallback';
import {
  GooglePhotoUriSchema,
  type PlaceDetails,
  type PlacesPort,
} from '@voll-intelligence/genui-contract';
export function PlacePhoto({
  photo,
  place,
  port,
  compact = false,
}: {
  readonly photo: PlaceDetails['photos'][number];
  readonly place: PlaceDetails;
  readonly port: PlacesPort;
  readonly compact?: boolean;
}) {
  const [uri, setUri] = useState<string | null>();
  useEffect(() => {
    let active = true;
    void port
      .getPhoto(photo.name)
      .then((photoUri) => {
        if (active) setUri(GooglePhotoUriSchema.safeParse(photoUri).success ? photoUri : null);
      })
      .catch(() => {
        if (active) setUri(null);
      });
    return () => {
      active = false;
    };
  }, [photo.name, port]);
  // A foto que não carrega some com a legenda: o crédito sem a foto não diz nada.
  const image = useImageFallback(uri);
  if (!image.src) return null;

  return (
    <figure
      className={
        compact
          ? 'overflow-hidden bg-muted'
          : 'min-w-64 snap-start overflow-hidden rounded-xl bg-muted'
      }
    >
      <img
        className={compact ? 'h-36 w-full object-cover' : 'h-44 w-full object-cover'}
        src={image.src}
        alt={place.name}
        loading="lazy"
        onError={image.onError}
      />
      {photo.authorAttributions.length > 0 && (
        <figcaption className="flex flex-wrap gap-x-2 px-3 py-2 text-xs text-muted-foreground">
          {photo.authorAttributions
            .filter((author) => author.displayName)
            .map((author, index) => (
              <span key={`${author.uri ?? author.displayName ?? ''}:${String(index)}`}>
                {author.uri ? (
                  <a href={author.uri} target="_blank" rel="noreferrer">
                    {author.displayName}
                  </a>
                ) : (
                  author.displayName
                )}
              </span>
            ))}
        </figcaption>
      )}
    </figure>
  );
}
